import { useCanGoBack, useRouter } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { Link } from "@/components/link";
import { cn } from "@/lib/utils";

export function BackLink({ className }: { className?: string }) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const classes = cn(
    "inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary",
    className
  );

  if (canGoBack) {
    return (
      <button
        className={classes}
        onClick={() => router.history.back()}
        type="button"
      >
        <ArrowLeft aria-hidden className="size-4" />
        Back
      </button>
    );
  }

  return (
    <Link className={classes} href="/explore">
      <ArrowLeft aria-hidden className="size-4" />
      Back to Explore
    </Link>
  );
}
